import { render, staticRenderFns } from "./queryGoodUnsalableList.vue?vue&type=template&id=b710b8e2"
import script from "./queryGoodUnsalableList.vue?vue&type=script&lang=js"
export * from "./queryGoodUnsalableList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports